/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";

/** Components */
import { Button, TablePagination, Paper, TableContainer, Table, TableHead, TableBody, TableCell, TableRow, TableFooter, Collapse, ButtonGroup, Tooltip } from "@mui/material";
import { FilterBy } from "../../commons/filter.component";
import LoadingProgress from "../../commons/LoadingProgress.component";
import ButtonWithAPICall from "../../../components/commons/ButtonWithAPICall.component";
import CustomDatePicker from "../../commons/CustomDatePicker";

/** Icons */
import SearchIcon from "@mui/icons-material/Search";

/** Api & Function */
import { getInventory, getRPTImpTruck, getVehicle } from "../../../services/api";
import { fitToColumn } from "../../../services/libService";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import moment from "moment";
import * as XLSX from "xlsx";

/** Hook */
import { useTranslation } from "react-i18next";
import { useParamFilter } from "../../commons/customHook";
import { ExcelIcon, PDFIcon } from "../../commons/miscellaneous";
import { useDispatch } from "react-redux";

export default function RPTImpTruck() {
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const [isSearchOpen, setSearchOpen] = useState(true);
  // custom hook
  const { fetchData, data, page, perPage, setPage, setPerPage, total, isAllow, loading, filter } = useParamFilter({ page: 1, per_page: 50 }, getRPTImpTruck);
  // state
  const [input, setInput] = useState({
    start_date: filter.start_date,
    end_date: filter.end_date,
    from_inventory: null,
    to_inventory: null,
    trucks: [],
  });

  const handleSearch = () => {
    fetchData((prev) => ({
      ...input,
      from_inventory: null,
      to_inventory: null,
      from_inventory_id: input.from_inventory?.id,
      to_inventory_id: input.to_inventory?.id,
      trucks: null,
      truck_ids: input.trucks.length ? JSON.stringify(input.trucks?.map((i) => i.id)) : "",
    }));
  };
  const handleClickDownloadCSV = () => {
    const params = {};
    if (input.start_date) params.start_date = input.start_date;
    if (input.end_date) params.end_date = input.end_date;
    if (input.from_inventory) params.from_inventory_id = input.from_inventory.id;
    if (input.to_inventory) params.to_inventory_id = input.to_inventory.id;
    if (input.trucks.length) params.truck_ids = JSON.stringify(input.trucks.map((i) => i.id));

    return getRPTImpTruck(params);
  };
  const exportExcel = (res) => {
    if (res.code === 200) {
      const arrayData = res.data.map((item) => ({
        // làm thế này để xác định những cột nào định dạng string trong file csv
        "Số HĐ": item.code,
        "Số phiếu KĐN": item.ext_inv_serial,
        "Ngày xuất": item.date ? moment(item.date).format("DD/MM/YYYY") : "",
        "Số xe vận chuyển": item.vehicle,
        "Dung tích xe (Ltt)": +item.exp_ltt,
        "V15 tại kho xuất": +item.exp_l15,
        "V15 tại kho nhập": +item.imp_l15,
        "Chênh lệch V15": +item.gap_l15,
        "Tỷ lệ (L/15)": +item.percent_l15,
        "D15 tại kho nhập": +item.imp_d15,
        "KG tại kho xuất": +item.exp_kg,
        "KG tại kho nhập": +item.imp_kg,
        "Chênh lệch KG": +item.gap_kg,
      }));
      const worksheet = XLSX.utils.json_to_sheet(arrayData);
      worksheet["!cols"] = fitToColumn(arrayData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet);
      XLSX.writeFileXLSX(workbook, "bdcxtn.xlsx");
    }
  };
  // effect
  useEffect(() => {
    dispatch(setHeaderTitle("BẢNG ĐỐI CHIẾU SỐ LƯỢNG NHẬP HÀNG XE XITEC"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <Button style={{ display: Boolean(data.length) ? "" : "none" }}>
            <PDFIcon />
          </Button>
          <ButtonWithAPICall disableSnackbar={() => true} response={exportExcel} api={handleClickDownloadCSV} style={{ display: Boolean(data.length) ? "" : "none" }}>
            <ExcelIcon />
          </ButtonWithAPICall>
          <Button onClick={() => setSearchOpen((prev) => !prev)} variant="outlined">
            <Tooltip title="Thư mục">
              <SearchIcon />
            </Tooltip>
          </Button>
        </ButtonGroup>
      </div>
      <div>
        <Collapse in={isSearchOpen}>
          <FilterBy
            style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
            getDataFunc={() => getInventory({ status: 1 })}
            value={input.from_inventory}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, from_inventory: newValue }))}
            label={t("Kho xuất")}
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, from_inventory: option.find((item) => item.id == filter.from_inventory_id) }))}
            triggerSetDefaultFunc={true}
            setDefaultDependencies={[filter.from_inventory_id]}
          />
          <FilterBy
            style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
            getDataFunc={() => getInventory({ status: 1 })}
            value={input.to_inventory}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, to_inventory: newValue }))}
            label={t("Kho nhập")}
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, to_inventory: option.find((item) => item.id == filter.to_inventory_id) }))}
            triggerSetDefaultFunc={true}
            setDefaultDependencies={[filter.to_inventory_id]}
          />
          <FilterBy
            style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
            multiple
            getOptionLabel={(option) => option.license_plate}
            getDataFunc={() => getVehicle({ status: 1 })}
            value={input.trucks}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, trucks: newValue }))}
            label={t("Xe vận chuyển")}
            setDefaultFunc={(option) =>
              setInput((prev) => ({ ...prev, trucks: JSON.isParseable(filter.truck_ids) ? option.filter((item) => JSON.parse(filter.truck_ids)?.indexOf?.(+item.id) >= 0) : [] }))
            }
            triggerSetDefaultFunc={Boolean(filter.truck_ids)}
            setDefaultDependencies={[filter.truck_ids]}
            filter={(option) => option.groupvehicle_id == 455911}
          />
          <CustomDatePicker label={t("Từ ngày")} value={input.start_date} onChange={(value) => setInput((prev) => ({ ...prev, start_date: value }))} sx={{ minWidth: "200px", margin: "5px" }} />
          <CustomDatePicker label={t("Đến ngày")} value={input.end_date} onChange={(value) => setInput((prev) => ({ ...prev, end_date: value }))} sx={{ minWidth: "200px", margin: "5px" }} />
          <Button variant="outlined" onClick={handleSearch} style={{ margin: "10px 0" }}>
            {t("Tìm kiếm")}
          </Button>
        </Collapse>
        <div style={{ display: "flex" }}>
          {loading ? (
            <LoadingProgress />
          ) : (
            <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
              <Table stickyHeader>
                <TableHead style={{ backgroundColor: "#f0f3f5" }}>
                  <TableRow>
                    <TableCell style={{ border: "1px solid lightgray" }} align="center">
                      STT
                    </TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }} align="center">
                      Số phiếu Kho ĐN
                    </TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }} align="center">
                      Số phiếu KĐN
                    </TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }} align="center">
                      Ngày xuất
                    </TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }} align="center">
                      Số xe vận chuyển
                    </TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }} align="center">
                      Dung tích xe (Ltt)
                    </TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }} align="center">
                      V15 tại kho xuất
                    </TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }} align="center">
                      V15 tại kho nhập
                    </TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }} align="center">
                      Chênh lệch V15 (%)
                    </TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }} align="center">
                      Tỷ lệ (L/15)
                    </TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }} align="center">
                      D15 tại kho nhập
                    </TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }} align="center">
                      KG tại kho xuất
                    </TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }} align="center">
                      KG tại kho nhập
                    </TableCell>
                    <TableCell style={{ border: "1px solid lightgray" }} align="center">
                      Chênh lệch KG
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.length ? (
                    data.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {index + (+filter.page - 1) * filter.per_page + 1}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.code}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.ext_inv_serial}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.date && moment(item.date).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.vehicle}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.exp_ltt?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.exp_l15?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.imp_l15?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.gap_l15?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.percent_l15}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.imp_d15?.toFixed(4)}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.exp_kg?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.imp_kg?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.gap_kg?.toLocaleString()}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={20}>
                        {t(isAllow ? "Không có dữ liệu" : "No permission")}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination rowsPerPageOptions={[50, 100, 150]} count={total || 0} rowsPerPage={perPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )}
        </div>
      </div>
    </div>
  );
}
